/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTeamsInvitationsInvitationidAcceptMutationResponse,
  PostTeamsInvitationsInvitationidAcceptPathParams,
  PostTeamsInvitationsInvitationidAccept400,
  PostTeamsInvitationsInvitationidAccept401,
  PostTeamsInvitationsInvitationidAccept404,
  PostTeamsInvitationsInvitationidAccept500,
} from "../types/PostTeamsInvitationsInvitationidAccept.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTeamsInvitationsInvitationidAcceptMutationKey = () =>
  [{ url: "/teams/invitations/:invitationId/accept" }] as const;

export type PostTeamsInvitationsInvitationidAcceptMutationKey = ReturnType<
  typeof postTeamsInvitationsInvitationidAcceptMutationKey
>;

/**
 * @description Принимает приглашение и добавляет пользователя в команду.
 * Статус приглашения изменяется на Accepted.
 * Капитан команды получает уведомление о принятии приглашения.
 * @summary Принять приглашение в команду
 * {@link /teams/invitations/:invitationId/accept}
 */
export async function postTeamsInvitationsInvitationidAccept(
  invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostTeamsInvitationsInvitationidAcceptMutationResponse,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidAccept400
      | PostTeamsInvitationsInvitationidAccept401
      | PostTeamsInvitationsInvitationidAccept404
      | PostTeamsInvitationsInvitationidAccept500
    >,
    unknown
  >({
    method: "POST",
    url: `/teams/invitations/${invitationId}/accept`,
    ...requestConfig,
  });
  return res;
}

export function postTeamsInvitationsInvitationidAcceptMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postTeamsInvitationsInvitationidAcceptMutationKey();
  return mutationOptions<
    ResponseConfig<PostTeamsInvitationsInvitationidAcceptMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidAccept400
      | PostTeamsInvitationsInvitationidAccept401
      | PostTeamsInvitationsInvitationidAccept404
      | PostTeamsInvitationsInvitationidAccept500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ invitationId }) => {
      return postTeamsInvitationsInvitationidAccept(invitationId, config);
    },
  });
}

/**
 * @description Принимает приглашение и добавляет пользователя в команду.
 * Статус приглашения изменяется на Accepted.
 * Капитан команды получает уведомление о принятии приглашения.
 * @summary Принять приглашение в команду
 * {@link /teams/invitations/:invitationId/accept}
 */
export function usePostTeamsInvitationsInvitationidAccept<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTeamsInvitationsInvitationidAcceptMutationResponse>,
      ResponseErrorConfig<
        | PostTeamsInvitationsInvitationidAccept400
        | PostTeamsInvitationsInvitationidAccept401
        | PostTeamsInvitationsInvitationidAccept404
        | PostTeamsInvitationsInvitationidAccept500
      >,
      {
        invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postTeamsInvitationsInvitationidAcceptMutationKey();

  const baseOptions = postTeamsInvitationsInvitationidAcceptMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTeamsInvitationsInvitationidAcceptMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidAccept400
      | PostTeamsInvitationsInvitationidAccept401
      | PostTeamsInvitationsInvitationidAccept404
      | PostTeamsInvitationsInvitationidAccept500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"];
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTeamsInvitationsInvitationidAcceptMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidAccept400
      | PostTeamsInvitationsInvitationidAccept401
      | PostTeamsInvitationsInvitationidAccept404
      | PostTeamsInvitationsInvitationidAccept500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTeamsInvitationsInvitationidAcceptMutationResponse>,
    ResponseErrorConfig<
      | PostTeamsInvitationsInvitationidAccept400
      | PostTeamsInvitationsInvitationidAccept401
      | PostTeamsInvitationsInvitationidAccept404
      | PostTeamsInvitationsInvitationidAccept500
    >,
    {
      invitationId: PostTeamsInvitationsInvitationidAcceptPathParams["invitationId"];
    },
    TContext
  >;
}
